<template>
  <v-container fluid>
    <!--gittest-->
    <page-header
      title="사이트청구 관리"
      @searchBtn="search_site_bill_mngt"
      @excelDown="excelDown"
      :custom-button-list="customButtonList"
      :useList="buttonUseList"
    />
    <v-card>
      <v-row class="pb-2" no-gutters>
        <v-col cols="1"></v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="search_type"
            :items="searchItem"
            item-text="txt"
            item-value="val"
            outlined
            dense
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            outlined
            dense
            hide-details
            v-model="search_word"
            @keyup.enter="search_site_bill_mngt"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <div id="realgrid" ref="realgrid" class="mt-1 mb-5 w-full"></div>
      </v-row>
    </v-card>
    <v-dialog v-model="isLayer" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h5">사이트청구 입력</v-card-title>
        <v-card-text class="pb-0">
          <!-- content -->
          <v-row class="mb-3" no-gutters>
            <v-col cols="3" class="sub_title">사이트 명</v-col>
            <v-col cols="9" class="sub_title">{{ site_nm }}</v-col>
          </v-row>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn @click="addItem" class="mr-2">+ 아이템 추가</v-btn>
            <v-btn @click="delItem">- 아이템 삭제</v-btn>
          </v-row>
        </v-card-text>
        <v-card
          class="ma-3 pa-2 pt-0 mb-2"
          v-for="(item, idx) in billItems"
          :key="idx"
          :id="'items_'+idx"
          ref="items_box"
          name="items_box"
        >
          <v-row no-gutters>
            <v-col cols="12">
              <v-checkbox
                class="mt-0"
                v-model="item.checkyn"
                :label="'아이템 ' + (idx + 1)"
                hide-details
                dense
              ></v-checkbox>
            </v-col>
            <v-col class="mr-2">
              <v-select
                :id="'itm_'+idx"
                :items="itemCodeList"
                item-text="txt"
                item-value="val"
                v-model="item.item"
                v-on:change="autoTemp(item)"
                dense
                small
                outlined
                hide-details
              ></v-select>
            </v-col>
            <v-col class="mr-2">
              <v-select
                :items="dialogSet"
                item-text="txt"
                item-value="val"
                v-model="item.qty"
                v-on:change="autoTemp(item)"
                dense
                small
                outlined
                hide-details
              ></v-select>
            </v-col>
            <v-col>
              <v-text-field
                type="number"
                pattern="[0-9]*"
                v-model="item.price"
                dense
                small
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="green darken-1" text @click="closeLayer">취소</v-btn>
          <v-btn color="green darken-1" text @click="saveSiteBillMngtMaster">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  getBillMngCodeList,
  getSiteBillMngtList,
  getSiteBillMngtDetail,
  setSiteBillMngtMaster,
  delSiteBillMngt,
  sendBillSms
} from '@/api/master/master'
import localStore from '@/utils/localStore'
import RealGridJS from 'realgrid/dist/main'
import PageHeader from '@/layout/components/PageHeader'

let dataProvider
let gridView

export default {
  name: 'SiteBillManage',
  components: {
    PageHeader
  },
  data() {
    return {
      buttonUseList: [],
      customButtonList: [
        { id: 'excelDown', text: '엑셀', icon: '' },
        { id: 'searchBtn', text: '조회', icon: 'mdi-magnify' }
      ],
      searchItem: [
        { txt: '사이트명', val: 'site_nm' },
        { txt: '사이트 ID', val: 'site_id' },
        { txt: '사용자명', val: 'user_nm' },
        { txt: '사용자 ID', val: 'user_id' }
      ],
      sendingMonth: [],
      sendingPrice: [],
      lastMonth: [],
      lastPrice: [],
      smsShow: false,
      nowDate: this.$time(Date.now()).format('YYYY-MM-DD'),
      siteBillMngtList: [],
      search_type: 'site_nm',
      search_word: '',
      site_id: '',
      site_nm: '',
      user_id: '',
      user_nm: '',
      phone: '',
      grid: {
        gridFields: [],
        gridColumns: [],
        gridOption: {},
        gridStyle: {}
      },
      isLayer: false,
      billItems: [1],
      dialogSet: [
        { txt: '1EA', val: '1' },
        { txt: '2EA', val: '2' },
        { txt: '3EA', val: '3' },
        { txt: '4EA', val: '4' }
      ],
      itemCodeList: [
        { txt: '100KW 미만', val: 'BASIC' },
        { txt: '100KW 이상', val: 'PLTE' },
        { txt: '100KW 미만 + CCTV', val: 'CCTV1' },
        { txt: '100KW 이상 + CCTV', val: 'CCTV2' },
        { txt: '100KW 미만(공유)', val: 'BASIC_NEW' },
        { txt: '100KW 이상(공유)', val: 'PLTE_NEW' },
        { txt: '유선 공유', val: 'LINE_SHARE' },
        { txt: '유선', val: 'LINE' }
      ],
      commonCode: [],
      beforeSelItem: ''
    }
  },
  mounted() {
    this.init_data()
    this.init_grid()
    this.smsShowFunc()
  },
  methods: {
    autoTemp(i) {
      // i.item , i.qty
      if (i.item === 'BASIC') {
        i.price = (20000 * Number(i.qty)).toString()
      } else if (i.item === 'PLTE') {
        i.price = (25000 * Number(i.qty)).toString()
      } else if (i.item === 'CCTV1') {
        i.price = (25000 * Number(i.qty)).toString()
      } else if (i.item === 'CCTV2') {
        i.price = (30000 * Number(i.qty)).toString()
      } else if (i.item === 'LINE') {
        i.price = (25000 * Number(i.qty)).toString()
      } else if (i.item === 'BASIC_NEW') {
        i.price = (15000 * Number(i.qty)).toString()
      } else if (i.item === 'PLTE_NEW') {
        i.price = (18000 * Number(i.qty)).toString()
      } else if (i.item === 'LINE_SHARE') {
        i.price = (17000 * Number(i.qty)).toString()
      }
    },
    smsShowFunc() {
      if ((this.$store.state.user.grp_auth || '') === 'usergroup001') {
        this.smsShow = true
      }
    },
    sendSMS() {
      // 체크된 줄 수 배열 저장
      let rows = gridView.getCheckedRows(true)
      console.log(rows)
      console.log(rows.length)
      if (confirm('문자를 발송 하시겠습니까?')) {
        let params = {
          search_type: this.search_type,
          search_word: this.search_word,
          sendingM: this.sendingMonth,
          sendingP: this.sendingPrice,
          sendingRows: rows
        }
        if (rows.length === 0) {
          alert('하나 이상의 사이트를 선택해 주세요')
          return
        } else {
          sendBillSms(params)
        }

        alert('발송 완료')
      } else {
        alert('발송 취소')
        return false
      }
    },
    excelDown() {
      gridView.exportGrid({
        type: 'excel',
        target: 'local',
        fileName: 'siteBill_' + this.nowDate + '.xlsx',
        // progressMessage: "엑셀 Export중입니다.",
        indicator: 'hidden',
        footer: 'hidden'
      })
    },
    init_data() {
      let params = {
        search_type: this.search_type,
        search_word: this.search_word
      }

      getSiteBillMngtList(params).then(response => {
        this.siteBillMngtList = response.siteBillList
        for (let i = 0; i < this.siteBillMngtList.length; i++) {
          this.lastMonth.push(this.siteBillMngtList[i].Month)
          this.lastPrice.push(this.siteBillMngtList[i].sumPrice)
        }
        this.sendingMonth.push(this.lastMonth)
        this.sendingPrice.push(this.lastPrice)
        console.log(this.sendingMonth)
        console.log(this.sendingPrice)
        dataProvider.fillJsonData(this.siteBillMngtList)
      })
      getBillMngCodeList(params).then(response => {
        this.commonCode = response
      })
    },
    search_site_bill_mngt() {
      let params = {
        search_type: this.search_type,
        search_word: this.search_word
      }
      getSiteBillMngtList(params).then(response => {
        this.siteBillMngtList = response.siteBillList
        dataProvider.fillJsonData(this.siteBillMngtList)
      })
    },
    siteBillMngtMasterDetail() {
      let params = {
        site_id: this.site_id
      }
      getSiteBillMngtDetail(params).then(response => {
        this.billItems = response
        this.isLayer = true
      })
    },
    saveSiteBillMngtMaster() {
      let cnt = 0
      let itemList = []

      $.each($("[name='items_box']"), function(idx, item) {
        let itemVal = $(item)
          .find('select')
          .eq(0)
          .val()
        let qtyVal = $(item)
          .find('select')
          .eq(1)
          .val()
        let priceVal = $(item)
          .find('input[type=text]')
          .val()
        if (itemVal && qtyVal && priceVal) {
        } else {
          cnt++
        }
        itemList.push({
          item: itemVal,
          qty: qtyVal,
          price: priceVal
        })
      })

      if (cnt > 0) {
        alert('아이템 정보를 입력해주세요.')
        return
      }

      let params = {
        user_id: this.user_id,
        site_id: this.site_id,
        login_id: localStore.get('userId'),
        item_list: itemList
      }

      delSiteBillMngt(params).then(response => {
        setSiteBillMngtMaster(params).then(response => {
          alert('저장되었습니다.')
          getSiteBillMngtList({}).then(response => {
            this.siteBillMngtList = response.siteBillList
            dataProvider.fillJsonData(this.siteBillMngtList)
            this.closeLayer()
          })
        })
        window.location.reload()
      })
    },
    closeLayer() {
      this.isLayer = false
      this.items = [1]
    },
    selItem(e) {
      this.beforeSelItem = e.target.value
    },
    addItem() {
      this.billItems.push({
        checkyn: false,
        qty: '1',
        price: '20000',
        price_text: '',
        item: 'BASIC'
      })
    },
    delItem() {
      console.log(this.billItems.length)
      if (this.billItems.length === 1) {
        this.billItems = []
      } else {
        for (let x = this.billItems.length - 1; x >= 0; x--) {
          console.log(this.billItems[x].checkyn)
          if (this.billItems[x].checkyn) {
            this.billItems.splice(x, 1)
          }
        }
      }
    },
    itemChange(gubun, e) {
      let item =
        gubun === 'item'
          ? e.target.value
          : $(e.target)
            .parent()
            .find('select')
            .eq(0)
            .val()
      let qty =
        gubun === 'item'
          ? $(e.target)
            .parent()
            .find('select')
            .eq(1)
            .val()
          : e.target.value
      let cnt = this.beforeSelItem ? 0 : -1

      // 중복 방지
      $.each($("[name='items_box']"), function(idx, items) {
        if (
          item ===
          $(items)
            .find('select')
            .eq(0)
            .val()
        ) {
          cnt++
        }
      })
      if (cnt > 0 && gubun === 'item') {
        alert('중복되는 아이템입니다.')
        $(e.target).val(this.beforeSelItem)
        return
      }

      // 금액 추가
      let attribute1 = 0
      $.each(this.commonCode, function(idx, code) {
        $.each(code, function(key, value) {
          if (value === item) attribute1 = code['attribute1'] * qty
          $(e.target)
            .parent()
            .find('input[type=text]')
            .val(attribute1)
        })
      })

      if (this.beforeSelItem) {
        this.items[Number(e.target.id.substr(4))].qty = qty
      } else {
        this.items[Number(e.target.id.substr(4))] = {
          item: item,
          qty: qty,
          price: attribute1
        }
      }
    },
    init_grid() {
      dataProvider = new RealGridJS.LocalDataProvider()
      gridView = new RealGridJS.GridView('realgrid')
      gridView.setDataSource(dataProvider)

      gridView.setOptions(this.grid.gridOption)
      gridView.setRowIndicator({
        visible: false
      })
      // gridView.setStyles(this.grid.gridStyle)

      // 체크박스
      gridView.setCheckBar({
        visible: true
      })

      let fields = [
        { fieldName: 'site_nm', dataType: 'string' },
        { fieldName: 'site_id', dataType: 'string' },
        { fieldName: 'user_nm', dataType: 'string' },
        { fieldName: 'user_id', dataType: 'string' },
        { fieldName: 'price_text', dataType: 'string' },
        { fieldName: 'phone', dataType: 'string' },
        { fieldName: 'Month', dataType: 'string' },
        { fieldName: 'sumPrice', dataType: 'string' }
      ]
      let columns = [
        {
          name: 'site_nm',
          fieldName: 'site_nm',
          header: { text: '사이트 명' },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'site_id',
          fieldName: 'site_id',
          header: { text: '사이트 ID' },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'user_nm',
          fieldName: 'user_nm',
          header: { text: '사용자' },
          hoveredBackground: '#ccc',
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'user_id',
          fieldName: 'user_id',
          header: { text: '사용자 ID' },
          hoveredBackground: '#ccc',
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'price_text',
          fieldName: 'price_text',
          header: { text: '청구금액' },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'phone',
          fieldName: 'phone',
          header: { text: '사업주 연락처' },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'Month',
          fieldName: 'Month',
          header: { text: '전월 발전량 (kWh)' },
          styles: {
            textAlignment: 'center'
          }
        },
        {
          name: 'sumPrice',
          fieldName: 'sumPrice',
          header: { text: '전월 예상 수익 (원)' },
          styles: {
            textAlignment: 'center'
          }
        }
      ]

      dataProvider.setFields(fields)
      gridView.setColumns(columns)
      // gridView.setSelectOptions({
      //   style: 'singleRow'
      // })
      gridView.onCellDblClicked = function(grid, index) {
        this.site_id = dataProvider.getValue(index.dataRow, 'site_id')
        this.site_nm = dataProvider.getValue(index.dataRow, 'site_nm')
        this.user_id = dataProvider.getValue(index.dataRow, 'user_id')

        this.siteBillMngtMasterDetail()
      }.bind(this)
    }
  },
  created() {
    if (this.$router.history.current.query.search_type !== undefined) {
      this.search_type = this.$router.history.current.query.search_type
    }
    if (this.$router.history.current.query.search_word !== undefined) {
      this.search_word = this.$router.history.current.query.search_word
    }
    this.grid.gridOption = {
      panel: {
        visible: false
      },
      stateBar: {
        visible: false
      },
      checkBar: {
        visible: false
      },
      indicator: {
        visible: false
      },
      footer: {
        visible: false
      },
      edit: {
        appendable: false,
        insertable: false,
        deletable: false,
        readOnly: false,
        editable: false,
        updatable: false
      },
      header: {
        styles: {
          fontSize: '14',
          fontFamily: 'NanumGothic',
          foreground: '#fff',
          fontBold: 'false',
          background: '#5c97cd',
          selectedBackground: '#9bb2c7',
          borderLeft: '#fff',
          borderRight: '#fff'
        },
        selection: {
          background: '#efefef',
          border: '#ccc,1'
        }
      },
      display: {
        fitStyle: 'evenFill',
        heightMeasurer: 'fixed',
        rowHeight: 30,
        focusVisible: false,
        showEmptyMessage: true,
        emptyMessage: '조회된 정보가 없습니다.'
      },
      sorting: {
        handleColor: '#fff',
        hoveredHandleColor: '#fff'
      },
      select: {
        style: 'none'
      }
    }

    this.grid.gridStyle = {
      body: {
        fontSize: '14',
        fontFamily: 'NanumGothic',
        foreground: '#666',
        fontBold: 'false',
        borderLeft: '#fff,0',
        borderRight: '#ccc,1',
        borderBottom: '#ccc,1',
        empty: {
          textAlignment: 'center',
          lineAlignment: 'center',
          fontSize: 14,
          fontBold: false
        },
        dynamicStyles: [
          {
            criteria: '(row mod 2) = 0',
            styles: {
              background: '#F4F4FA'
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang='less' scoped>
// @import '../../../assets/manage.less';

#realgrid {
  height: 500px;
  width: 100%;
  margin-top: 0;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
}

.layer_frame {
  overflow: auto;
}

.btn {
  display: inline-block;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #b1b1b1;
  background: #ededed;
  color: #676767;
  cursor: pointer;
  font-weight: bold;
  line-height: 30px;
}

.btn:first-child {
  margin-right: 5px;
}

.com_select {
  display: flex;
}
.com_select > select {
  margin-right: 5px;
}

.price_text {
  text-align: right;
}

.excel_down {
  width: 80px;
  height: 27px;
  border: 1px solid #24943e;
  color: #24943e;
  text-align: center;
  line-height: 28px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;
  background-color: #fff;
  margin-right: 10px;
}

.SMS {
  width: 100px;
  height: 27px;
  border: 1px solid red;
  color: red;
  text-align: center;
  line-height: 28px;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;
  background-color: #fff;
  margin-right: 10px;
}

.fr_area {
  width: 1800px;
  display: flex;
}
</style>
